import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer__container">
        <div className="footer__content">
          {/* Brand Section */}
          <div className="footer__section">
            <div className="footer__brand">
              <span className="footer__logo-icon">👨‍💻</span>
              <span className="footer__logo-text">My Nerdy Son</span>
            </div>
            <p className="footer__description">
              Your friendly technology helper, providing patient guidance 
              for all your tech questions and concerns.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer__section">
            <h3 className="footer__heading">Quick Links</h3>
            <ul className="footer__links">
              <li>
                <Link to="/" className="footer__link">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/chat" className="footer__link">
                  Chat
                </Link>
              </li>
              <li>
                <Link to="/knowledge-base" className="footer__link">
                  Help Topics
                </Link>
              </li>
              <li>
                <Link to="/settings" className="footer__link">
                  Settings
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div className="footer__section">
            <h3 className="footer__heading">Support</h3>
            <ul className="footer__links">
              <li>
                <a href="mailto:help@mynerdyson.com" className="footer__link">
                  Email Support
                </a>
              </li>
              <li>
                <a href="tel:1-800-NERDY-SON" className="footer__link">
                  Phone Support
                </a>
              </li>
              <li>
                <Link to="/accessibility" className="footer__link">
                  Accessibility
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="footer__link">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer__section">
            <h3 className="footer__heading">Contact</h3>
            <div className="footer__contact">
              <p>
                <strong>Email:</strong><br />
                <a href="mailto:help@mynerdyson.com" className="footer__link">
                  help@mynerdyson.com
                </a>
              </p>
              <p>
                <strong>Phone:</strong><br />
                <a href="tel:1-800-637-3976" className="footer__link">
                  1-800-NERDY-SON
                </a>
              </p>
              <p className="footer__hours">
                <strong>Support Hours:</strong><br />
                Monday - Friday: 8 AM - 6 PM<br />
                Saturday: 9 AM - 4 PM<br />
                Sunday: Closed
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer__bottom">
          <div className="footer__bottom-content">
            <p className="footer__copyright">
              © {currentYear} My Nerdy Son. All rights reserved.
            </p>
            
            <div className="footer__bottom-links">
              <Link to="/terms" className="footer__bottom-link">
                Terms of Service
              </Link>
              <Link to="/privacy" className="footer__bottom-link">
                Privacy Policy
              </Link>
              <Link to="/accessibility" className="footer__bottom-link">
                Accessibility Statement
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};